import { Component, OnInit, Input, OnChanges } from "@angular/core";
import {
  AdvisorFacade,
  AdvisorWithDisplayPhone,
  EntityExData,
  parseNumber,
} from "common";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { ActivatedRoute } from "@angular/router";
import { EntityFacade } from "../../entity/domain/+state/entity.facade";
import { BehaviorSubject, of } from "rxjs";
import { switchMap } from "rxjs/operators";

@UntilDestroy()
@Component({
    selector: "ifp-advisor-widget",
    templateUrl: "./advisor-widget.component.html",
    styleUrls: ["./advisor-widget.component.scss"],
    standalone: false
})
export class AdvisorWidgetComponent implements OnInit, OnChanges {
  private currentEntity: EntityExData;
  data: any;
  advisorData: AdvisorWithDisplayPhone | null;

  private readonly advisorId$ = new BehaviorSubject<number | undefined>(
    undefined
  );

  @Input()
  value: any;

  constructor(
    private entityFacade: EntityFacade,
    private route: ActivatedRoute,
    private advisorFacade: AdvisorFacade
  ) { }

  ngOnInit(): void {
    this.advisorId$
      .pipe(
        untilDestroyed(this),
        switchMap((id) =>
          id ? this.advisorFacade.getAdvisorWithPhone$(id) : of(null)
        )
      )
      .subscribe((advisor) => {
        this.advisorData = advisor;
      });

    this.entityFacade
      .getEntity$(parseNumber(this.route.snapshot.queryParams.companyId))
      .pipe(untilDestroyed(this))
      .subscribe((entity: EntityExData) => {
        if (entity) {
          this.currentEntity = entity;
          this.updateData();
        }
      });
  }

  ngOnChanges(): void {
    this.updateData();
  }

  private updateData(): void {
    this.data = this.value ? this.value : this.currentEntity;
    this.advisorId$.next(this.data?.advisorId);
  }

  mailLink(email: string): string {
    return `mailto:${email}`;
  }

  calendarLink(): void {
    window.open(
      this.advisorData?.calendarLinkUrl ?? "https://calendly.com/ideafinancial",
      "_blank"
    );
  }
}
